// FAZ G — Taslak kurtarma. Taslaklar YALNIZCA tarayıcı deposunda tutulur,
// sunucuya gönderilmez. Anahtar kullanıcıya özeldir; başka kullanıcı aynı
// tarayıcıda giriş yaptığında başkasının taslağını görmez.
const ONEK = "sertex_draft_v1";
const OMUR_MS = 24 * 60 * 60 * 1000; // 24 saat
const MAKS_BAYT = 200 * 1024; // tek taslak üst sınırı
const MAKS_ADET = 20; // en yeniler kalır

const anahtar = (userId, formKey) => `${ONEK}:${userId || "anon"}:${formKey}`;

const tumAnahtarlar = () => {
  const out = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const k = localStorage.key(i);
    if (k && k.startsWith(`${ONEK}:`)) out.push(k);
  }
  return out;
};

const oku = (k) => {
  try {
    const raw = localStorage.getItem(k);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || typeof o.at !== "number") return null;
    return o;
  } catch {
    return null;
  }
};

// Süresi geçmiş taslakları sil + adet sınırını uygula (uygulama açılışında).
export const taslaklariBudama = () => {
  const simdi = Date.now();
  const kalan = [];
  for (const k of tumAnahtarlar()) {
    const o = oku(k);
    if (!o || simdi - o.at > OMUR_MS) { localStorage.removeItem(k); continue; }
    kalan.push({ k, at: o.at });
  }
  if (kalan.length > MAKS_ADET) {
    kalan.sort((a, b) => b.at - a.at);
    kalan.slice(MAKS_ADET).forEach((x) => localStorage.removeItem(x.k));
  }
};

export const taslakKaydet = (userId, formKey, veri) => {
  try {
    const paket = JSON.stringify({ at: Date.now(), veri });
    if (paket.length > MAKS_BAYT) return false; // sessiz yanlış umut yok
    localStorage.setItem(anahtar(userId, formKey), paket);
    return true;
  } catch {
    return false;
  }
};

export const taslakOku = (userId, formKey) => {
  const k = anahtar(userId, formKey);
  const o = oku(k);
  if (!o) return null;
  if (Date.now() - o.at > OMUR_MS) { localStorage.removeItem(k); return null; }
  return o;
};

export const taslakSil = (userId, formKey) => {
  try { localStorage.removeItem(anahtar(userId, formKey)); } catch { /* yoksay */ }
};

export const dakikaOnce = (at) => {
  const dk = Math.max(0, Math.round((Date.now() - at) / 60000));
  if (dk < 1) return "az önce";
  if (dk < 60) return `${dk} dakika önce`;
  const s = Math.round(dk / 60);
  return `${s} saat önce`;
};
